import * as Yup from "yup";
import React from "react";

// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import EditIcon from "@mui/icons-material/Edit";
// @mui
import { responsiveValue } from "../../../theme/Styles/responsiveValue";

import { Stack, Paper, Typography, Divider, Button, Grid } from "@mui/material";

import { LoadingButton } from "@mui/lab";
// components

import { FormProvider, RHFTextField } from "../../../components/hook-form";

//redux
import { useDispatch, useSelector } from "react-redux";
import { addUserContact } from "../../../Containers/OnBoarding/slice";
import Snackbar from "../../../components/Snackbar";
import {
  getChildEntitiesList,
  getUserEntity,
} from "../../../redux/features/authSlice";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../../Containers/AdminView/adminSlice";
import { useSnackbar } from "notistack";
import { RegistrationStatus } from "../../../common/enum";

const ContactForm = ({
  t,
  setBlock,
  block,
  details,
  setDetails,
  contact,
  editFromEstablishment,
  loggedInUser,
  refreshDetails,
}) => {
  const {
    id,
    contactId,
    entityId,
    designation,
    mobile,
    name,
    email,
    telephone,
    isPrimaryContact,
    isOfficialRepresentative,
  } = contact || {};

  const [editContact, setEditContact] = React.useState(false);

  const {
    auth: {
      user: { userId, status , managerName} = {},
      branchEntitiesOffset,
      branchEntitiesLimit,
    } = {},
    onBoarding: { snackbarSeverity, snackbarOpen, snackbarMessage },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  const identificationSchema = Yup.object().shape({
    name: Yup.string().required(`${t("contactName")} é de preenchimento obrigatório`),
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(`${t("email")} é de preenchimento obrigatório`),
    phone: Yup.string()
    .required(`O campo ${t("mobile")} é de preenchimento obrigatório`)
    .matches(/^(\+[\d]{1,5}|0)?[0-9]+$/, "devem ser apenas números")
    .length(9, "O campo contato telefónico tem que ter 9 dígitos"),
    designation: Yup.string().required(`${t("designation")} é de preenchimento obrigatório `),
  });

  const defaultValues = {
    name: name,
    email: email,
    phone: mobile,
    designation: designation,
  };

  const methods = useForm({
    resolver: yupResolver(identificationSchema),
    defaultValues,
  });
  const { enqueueSnackbar } = useSnackbar();

  const { handleSubmit } = methods;
  const onSubmit = React.useCallback(
    (data) => {
      const contactPayload = {
        id,
        contactId,
        entityId,
        designation: data.designation,
        mobile: data.phone,
        name: data.name,
        email: data.email,
        telephone,
        isPrimaryContact,
        isOfficialRepresentative,
        updatedBy: editFromEstablishment ? loggedInUser.entityId : entityId,
      };
      dispatch(addUserContact(contactPayload))
        .unwrap()
        .then((res) => {
          enqueueSnackbar({
            message: t("contactDetailSuccessfullyUpdated"),
            variant: "success",
          });
          if (editFromEstablishment) {
            if (refreshDetails) {
              refreshDetails();
            }
          } else {
            dispatch(getUserEntity(entityId));
          }
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("someThingWentWrong"),
            variant: "error",
          });
        });
    },
    [dispatch]
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  return (
    <>
      <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
              }}
            >
      {managerName == null &&
        <Stack direction={"row"} justifyContent="end" width={1}>
        <Button
          onClick={() => setEditContact(true)}
          startIcon={<EditIcon />}
          variant="contained"
          sx={{ borderRadius: "4px" }}
          disabled={
            status === RegistrationStatus.inActive ||
            status === RegistrationStatus.inAtivo ||
            status === RegistrationStatus.revoked
          }
        >
          {t("edit")}
        </Button>
      </Stack>
      }
      {editContact === true && (
        <Grid
          marginTop="20px"
          container
          spacing={responsiveValue("", "", "", "2", "2", "0")}
          direction={responsiveValue(
            "",
            "",
            "",
            "row",
            "row",
            "column-reverse"
          )}
          justifyContent={"space-evenly"}
        >
          <Grid item marginTop={responsiveValue("", "", "", "0", "0", "90px")}>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Stack spacing={3}>
                <Paper sx={{ padding: "20px" }}>
                  {/* <Typography>{t("editPrimaryContact")}</Typography> */}
                  <RHFTextField
                    id="outlined-basic"
                    label={t("contactName")}
                    variant="outlined"
                    name="name"
                    // type='number'
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("mobile")}
                    variant="outlined"
                    name="phone"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                    inputProps={{ maxLength: 9 }}
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("emailAddress")}
                    variant="outlined"
                    name="email"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <RHFTextField
                    id="outlined-basic"
                    label={t("designation")}
                    variant="outlined"
                    name="designation"
                    sx={{ marginTop: "20px" }}
                    fullWidth
                  />
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    marginTop={2}
                  >
                    <Button
                      onClick={() => setEditContact(false)}
                      sx={{
                        background: "#FFEEEE",
                        color: "#FF0000",
                        padding: "8px 22px",
                        borderRadius: "4px",
                        "&:hover": { background: "#FF0000", color: "#FFEEEE" },
                      }}
                    >
                      {t("cancel")}
                    </Button>
                    
                    <LoadingButton
                      sx={{
                        borderRadius: "4px",
                      }}
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      {t("toSave")}
                    </LoadingButton>
                  </Stack>
                </Paper>
              </Stack>
            </FormProvider>
          </Grid>
        </Grid>
      )}
      {editContact === false && (
        <Stack mt={2} direction={"column"} gap={1} width={1}>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("contactName")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {name}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("emailAddress")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {email}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("mobile")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px", fontSize:"14px" }}>
              {mobile}
            </Typography>
          </Stack>
          <Stack
            direction={"column"}
            alignItems="left"
            justifyContent={"space-between"}
            width={1}
          >
            <Typography variant="h4" style={{fontSize:"14px"}}>{t("designation")}</Typography>
            <Typography sx={{ marginTop: "5px", marginBottom: "5px" , fontSize:"14px"}}>
              {designation}
            </Typography>
          </Stack>
        </Stack>
      )}
      {snackbarOpen && (
        <Snackbar
          t={t}
          severity={snackbarSeverity}
          open={snackbarOpen}
          onClose={handleClose}
          sx={{ width: "100%" }}
          message={snackbarMessage}
        />
      )}
      </Paper>
    </>
  );
};

export default ContactForm;
